var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("h6", [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: `/#/portfolio-plan/selection/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.scenarioId}`,
                            expression:
                              "`/#/portfolio-plan/selection/${workspaceId}/${tchProjectId}/${scenarioId}`",
                          },
                        ],
                        staticClass: "text-dark",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-double-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Back to plan\n                    "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v(_vm._s(_vm.rm.ResourceName))]
                  ),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "col-lg-6 text-right align-self-end",
                }),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "my-5" }),
              _vm._v(" "),
              _c("table", { staticClass: "table table-bordered" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Project")]),
                    _vm._v(" "),
                    _c("th", { attrs: { rowspan: "2" } }, [
                      _vm._v("Selection"),
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { rowspan: "2" } }, [
                      _vm._v("Start date"),
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { colspan: "3" } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.rm.ResourceName) +
                          " [" +
                          _vm._s(_vm.rm.ResourceUnit) +
                          "]\n                    "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.rm.Projects, function (p) {
                    return _c("tr", { key: p.Id }, [
                      _c("td", [_vm._v(_vm._s(p.Name))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(p.Acceptance))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(p.StartDate))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(p.ResourceRequested))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(p.ResourceCommitted))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(p.ResourcePlanned))]),
                    ])
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("tr", [
      _c("th", [_vm._v("Requested")]),
      _vm._v(" "),
      _c("th", [_vm._v("Committed")]),
      _vm._v(" "),
      _c("th", [_vm._v("Planned")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }